import React, { useState, useEffect } from "react";
import { INPUT_DIRECTION } from "../../constants/hardCodedConstants";
import AsyncSelectInputCustomPost from "../Select/AsyncSelectInputCustomPost";

const InputSearchAsyncPost = ({
  label,
  api,
  name,
  onChange,
  sectionName,
  value,
  valueText,
  isRequired,
  isDisabled,
  direction = "row",
  placeholder = "Buscar por nombre",
  isMulti = false,
  buildPayload
}) => {

  const [valueSelected, setValueSelected] = useState(null);

    const handleOnChange = (res) => {
        setValueSelected(res);
        onChange({
            target: {
                value: res,
                name
            }
        });
    };

    useEffect(() => {
        if (!isMulti) {
            if (value && valueText) {
                setValueSelected({
                    value: value,
                    label: valueText
                });
            } else {
                setValueSelected(null);
            }
        }
    }, [value, valueText, isMulti]);

  return (
    <div className={`${INPUT_DIRECTION[direction]}`}>
      <label className={`modal-label ${isRequired ? "required" : ""}`}>
        {label}
      </label>
      <div className="black-color">
        {  <AsyncSelectInputCustomPost
            api={api}
            placeholder={placeholder}
            handleSelectInputChange={handleOnChange}
            isDisabled={isDisabled}
            value={valueSelected}
            isMulti={isMulti}
            buildPayload={buildPayload}
          />
        }
        <p
          className="ficha-form-input-validation-message"
          id={`ficha-edit-${sectionName}-${name}-validation-message`}
        ></p>
      </div>
    </div>
  );
};

export default InputSearchAsyncPost;
